import _ from 'lodash';

export const DEFAULT_LOCALE = 'en';

export const INTL_LOCALE_OVERRIDES = {
  no: 'nb-NO',
};

export const AVAILABLE_LOCALES = process.env.AVAILABLE_LOCALES || [
  DEFAULT_LOCALE,
];

export function cleanLocale(locale) {
  return _.includes(AVAILABLE_LOCALES, locale) ? locale : DEFAULT_LOCALE;
}
